import { render, staticRenderFns } from "./zzxIndex.vue?vue&type=template&id=c5041676&scoped=true&"
import script from "./zzxIndex.vue?vue&type=script&lang=js&"
export * from "./zzxIndex.vue?vue&type=script&lang=js&"
import style0 from "./zzxIndex.vue?vue&type=style&index=0&id=c5041676&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5041676",
  null
  
)

export default component.exports